import {
  BILLS_SUCCESS,
  ACCOUNTS_LOADING,
  SET_ROLE_PERMISSIONS_LOADING,
  SET_ROLE_PERMISSIONS_STATUSES,
  SET_ROLE_PERMISSIONS_ACCOUNT_RESTRICTED_EVENTS,
  SET_ROLE_PERMISSIONS_SUPPORT_FILE_RESTRICTIONS,
  SET_FILTERS_CONFIGURATION,
  SET_SELECTED_DATE,
  SET_SELECTED_ACCOUNT,
  SET_ACCOUNT_CHARGES_LOADING,
  SET_ACCOUNT_CHARGES,
  SET_ALL_SUPPORT_DOCUMENT_FILES,
  SET_SUPPORT_FILES_LOADING,
  SET_SUPPORT_FILES_BY_CHARGE,
  SET_SUPPORT_FILES_BY_ACCOUNT,
  SET_SELECTED_CHARGE,
  SET_COMMENTS_ACCOUNT,
  SET_AGRREMENTS_LOADING,
  SET_AGREMENTS,
  SET_PAYERS,
  SET_SELECTED_AGREEMENT,
  SET_AGREEMENT_CONFIGURATION,
  SET_SELECTED_AUDIT_RULE,
  SET_HEALTHCARE_PLANS,
  SET_SERVICE_SUPPORT_DOCUMENTS_LOADING,
  SET_SERVICE_SUPPORT_DOCUMENTS_ACCOUNT,
  SET_SERVICE_SUPPORT_DOCUMENTS_CHARGE,
  SET_SUPPORT_FILE_TYPES,
  SET_AGREEMENT_PRODUCTS_LOADING,
  SET_AGREEMENT_PRODUCTS,
  SET_DISPLAY_DIALOG_COMMENT,
  SET_COMMENT_CONTROL,
  SET_PAYERS_AVAILABLE,
  SET_IS_INVOICED_AND_IS_CONCURRENT_ACCOUNT,
  SET_ROLE_RCM_USER,
  SET_PROVIDER_SERVICE_TYPES,
  SET_PROVIDER_EXECUTOR_SERVICES,
  SET_PROVIDER_AGREEMENT_PLAN_TYPES,
  SET_PROVIDER_INVOICE_SOURCES,
	SET_PROVIDER_AGREEMENTS,
  SET_PROVIDER_SUPPORT_DOCUMENTS,
  SET_ACCOUNT_LIST_SORT,
  SET_AGREEMENT_FILTERS,
  SET_PRE_SETTLEMENTS,
  SET_PRE_SETTLEMENTS_FILTER,
  SET_PRE_SETTLEMENTS_DETAIL,
  SET_ACCOUNTS_SEARCH_VALUE,
  SET_ACCOUNT_CHARGES_FILTER,
  SET_IS_MULTI_PATIENT_ACCOUNT,
  SET_IS_MULTI_EVENT_SAME_PATIENT_ACCOUNT,
  SET_SUPPORT_DOCUMENTS_LOADING,
  SET_SUPPORT_DOCUMENTS,
  SET_SUPPORT_FORMAT_FILE_FIELDS,
  SET_SELECTED_PACKAGE_GROUP,
  SET_PROVIDER_PRODUCTS,
  SET_PROVIDER_PRODUCTS_SEARCH_VALUE,
  SET_PROVIDER_PRODUCTS_LOADING,
  SET_PROVIDER_PRODUCT_CONFIGURATION_DIALOG,
  SET_SELECTED_PROVIDER_PRODUCT,
  SET_SELECTED_PROVIDER_PRODUCT_CONFIGURATION,
  SET_ACCOUNT_DEFAULT_FILTERS_VALUES_APPLIED,
  SET_PRE_SETTLEMENT_FOLDER_CONFIGURATION,
  SET_UPLOADED_AGREEMENT_MATRIX,
  SET_UPLOADED_AGREEMENT_MATRIX_LOADING,
  SET_UPLOAD_AGREEMENT_MATRIX_RESULT,
  SET_UPLOAD_AGREEMENT_MATRIX_RESULT_LOADING,
  SET_USERS,
  REASSIGNED_BILLS_SUCCESS,
  REASSIGNED_ACCOUNTS_LOADING,
} from './mutation-types'

export default {
  [BILLS_SUCCESS]: (state, payload) => {
    state.accounts = payload.content
    state.links = payload.links
    state.page = payload.page
  },
  [ACCOUNTS_LOADING]: (state, payload) => {
    state.loadingAccounts = payload
  },
  [SET_FILTERS_CONFIGURATION]: (state, payload) => {
    state.filtersConfiguration = payload
  },
  [SET_ROLE_PERMISSIONS_LOADING]: (state, payload) => {
    state.rolePermissions.loading = payload
  },
  [SET_ROLE_PERMISSIONS_STATUSES]: (state, payload) => {
    state.rolePermissions.statusesPermissions = payload
  },
  [SET_ROLE_PERMISSIONS_ACCOUNT_RESTRICTED_EVENTS]: (state, payload) => {
    state.rolePermissions.accountEventRestrictions = payload
  },
  [SET_ROLE_PERMISSIONS_SUPPORT_FILE_RESTRICTIONS]: (state, payload) => {
    state.rolePermissions.supportFileRestrictions = payload
  },
  [SET_SELECTED_DATE]: (state, payload) => {
    if (payload.type === 'clean') {
      state.selectedDates.dateFrom = null
      state.selectedDates.dateTo = null
    }
    if (payload.type === 'from') {
      state.selectedDates.dateFrom = payload.date
    }
    if (payload.type === 'to') {
      state.selectedDates.dateTo = payload.date
    }
  },
  [SET_SELECTED_ACCOUNT]: (state, payload) => {
    state.accountDetail.selectedAccount = payload
  },
  [SET_ACCOUNT_CHARGES_LOADING]: (state, payload) => {
    state.accountDetail.accountCharges.loading = payload
  },
  [SET_ACCOUNT_CHARGES]: (state, payload) => {
    state.accountDetail.accountCharges.charges = payload.content
    state.accountDetail.accountCharges.links = payload.links
    state.accountDetail.accountCharges.page = payload.page
  },
  [SET_ACCOUNT_CHARGES_FILTER]: (state, payload) => {
    state.accountDetail.accountCharges.filters = payload
  },
  [SET_IS_MULTI_PATIENT_ACCOUNT]: (state, payload) => {
    state.accountDetail.isMultiPatientAccount = payload
  },
  [SET_IS_MULTI_EVENT_SAME_PATIENT_ACCOUNT]: (state, payload) => {
    state.accountDetail.isMultiEventSamePatientAccount = payload
  },
  [SET_SUPPORT_FILES_LOADING]: (state, payload) => {
    state.accountDetail.supportFiles.loading = payload
  },
  [SET_ALL_SUPPORT_DOCUMENT_FILES]: (state, payload) => {
    const { response, status } = payload
    const key = status ? status.toLowerCase() : 'general'

    state.accountDetail.supportFiles.all[key].files = response.content
    state.accountDetail.supportFiles.all[key].page = response.page
  },
  [SET_SUPPORT_FILES_BY_CHARGE]: (state, payload) => {
    const { response, status } = payload
    const key = status ? status.toLowerCase() : 'general'

    state.accountDetail.supportFiles.byCharge[key].files = response.content
    state.accountDetail.supportFiles.byCharge[key].page = response.page
  },
  [SET_SUPPORT_FILES_BY_ACCOUNT]: (state, payload) => {
    const { response, status } = payload
    const key = status ? status.toLowerCase() : 'general'

    state.accountDetail.supportFiles.byAccount[key].files = response.content
    state.accountDetail.supportFiles.byAccount[key].page = response.page
  },
  [SET_SELECTED_CHARGE]: (state, payload) => {
    state.chargeDetail.selectedCharge = payload
  },
  [SET_COMMENTS_ACCOUNT]: (state, payload) => {
    state.auditComments = payload
  },
  [SET_AGRREMENTS_LOADING]: (state, payload) => {
    state.agreements.loading = payload
  },
  [SET_AGREMENTS]: (state, payload) => {
    state.agreements.content = payload.content
    state.agreements.links = payload.links
    state.agreements.page = payload.page
  },
  [SET_PAYERS]: (state, payload) => {
    state.payers = payload
  },
  [SET_SELECTED_AGREEMENT]: (state, payload) => {
    state.selectedAgreement = payload
  },
  [SET_AGREEMENT_CONFIGURATION]: (state, payload) => {
    state.agreementConfiguration = payload
  },
  [SET_SELECTED_AUDIT_RULE]: (state, payload) => {
    state.selectedAuditRule = payload
  },
  [SET_HEALTHCARE_PLANS]: (state, payload) => {
    state.healthcarePlans = payload
  },
  [SET_SERVICE_SUPPORT_DOCUMENTS_LOADING]: (state, payload) => {
    state.serviceSupportDocuments.loading = payload
  },
  [SET_SERVICE_SUPPORT_DOCUMENTS_ACCOUNT]: (state, payload) => {
    state.serviceSupportDocuments.byAccount.files = payload.content
    state.serviceSupportDocuments.byAccount.page = payload.page
  },
  [SET_SERVICE_SUPPORT_DOCUMENTS_CHARGE]: (state, payload) => {

    if(payload.pushNewResults){
      state.serviceSupportDocuments.byCharge.files.push(...payload.response.content)
    }else{
      state.serviceSupportDocuments.byCharge.files = payload.response.content
    }

    state.serviceSupportDocuments.byCharge.page = payload.response.page
  },
  [SET_SUPPORT_FILE_TYPES]: (state, payload) => {
    state.supportFileTypes = payload
  },
  [SET_AGREEMENT_PRODUCTS_LOADING]: (state, payload) => {
    state.agreementProducts.loading = payload
  },
  [SET_AGREEMENT_PRODUCTS]: (state, payload) => {
    state.agreementProducts.content = payload.content
    state.agreementProducts.page = payload.page
  },
  [SET_DISPLAY_DIALOG_COMMENT]: (state, payload) => {
    state.displayCommentDialog = payload;
  },
  [SET_COMMENT_CONTROL]: (state, payload) => {
    state.commentControl = payload;
  },
  [SET_PAYERS_AVAILABLE]: (state, payload) => {
    state.payers = payload;
  },
  [SET_IS_INVOICED_AND_IS_CONCURRENT_ACCOUNT]: (state, payload) => {
    if(payload){
        const { isConcurrentAccount, isInvoicedAccount, isReadyToAudit } = payload
        state.accountDetail.isConcurrentAccount = isConcurrentAccount
        state.accountDetail.isInvoicedAccount = isInvoicedAccount,
        state.accountDetail.isReadyToAudit = isReadyToAudit
    }
  },
  [SET_ROLE_RCM_USER]: (state, payload) => {
        state.roleRcmUser = payload
  },
  [SET_PROVIDER_SERVICE_TYPES]: (state, payload) => {
    state.providerServiceTypes = payload
  },
  [SET_PROVIDER_EXECUTOR_SERVICES]: (state, payload) => {
    state.providerExecutorServices = payload
  },
	[SET_PROVIDER_AGREEMENTS]: (state, payload) => {
    state.providerAgreements = payload
  },
  [SET_PROVIDER_SUPPORT_DOCUMENTS]: (state, payload) => {
    state.providerSupportDocuments = payload
  },
  [SET_PROVIDER_AGREEMENT_PLAN_TYPES]: (state, payload) => {
    state.providerAgreementPlanTypes = payload
  },
  [SET_PROVIDER_INVOICE_SOURCES]: (state, payload) => {
    state.providerInvoiceSources = payload
  },
  [SET_ACCOUNT_LIST_SORT]: (state, payload) => {
    state.accountListSort = payload
  },
  [SET_AGREEMENT_FILTERS]: (state, payload) => {
    state.agreementsFilters = payload
  },
  [SET_PRE_SETTLEMENTS]: (state, payload) => {
    state.preSettlements.content = payload.content
    state.preSettlements.links = payload.links
    state.preSettlements.page = payload.page
  },
  [SET_PRE_SETTLEMENTS_FILTER]: (state, payload) => {
    state.preSettlements.filters = payload
  },
  [SET_UPLOADED_AGREEMENT_MATRIX]: (state, payload) => {
    state.uploadedAgreementMatrix.content = payload.content
    state.uploadedAgreementMatrix.links = payload.links
    state.uploadedAgreementMatrix.page = payload.page
  },
  [SET_UPLOADED_AGREEMENT_MATRIX_LOADING]: (state, payload) => {
    state.uploadedAgreementMatrix.loading = payload
  },
  [SET_UPLOAD_AGREEMENT_MATRIX_RESULT]: (state, payload) => {
    state.uploadAgreementMatrixResult.status = payload.status
    state.uploadAgreementMatrixResult.errors = payload.errors
    state.uploadAgreementMatrixResult.status = payload.status
  },
  [SET_UPLOAD_AGREEMENT_MATRIX_RESULT_LOADING]: (state, payload) => {
    state.uploadAgreementMatrixResult.loading = payload
  },
  [SET_PRE_SETTLEMENTS_DETAIL]: (state, payload) => {
    state.preSettlementDetail = payload
  },
  [SET_ACCOUNTS_SEARCH_VALUE]: (state, payload) => {
    state.accountsSearchValue = payload
  },
  [SET_SUPPORT_DOCUMENTS_LOADING]: (state, payload) => {
    state.supportDocuments.loading = payload
  },
  [SET_SUPPORT_DOCUMENTS]: (state, payload) => {
    state.supportDocuments.documents = payload
  },
  [SET_SUPPORT_FORMAT_FILE_FIELDS]: (state, payload) => {
    state.supportFormatFileFields = payload
  },
  [SET_SELECTED_PACKAGE_GROUP]: (state, payload) => {
    state.selectedPackageGroup = payload
  },
  [SET_PROVIDER_PRODUCTS]: (state, payload) => {
    state.providerProducts = payload
  },
  [SET_PROVIDER_PRODUCTS_SEARCH_VALUE]: (state, payload) => {
    state.providerProductsSearchValue = payload
  },
  [SET_PROVIDER_PRODUCTS_LOADING]: (state, payload) => {
    state.providerProductsLoading = payload
  },
  [SET_PROVIDER_PRODUCT_CONFIGURATION_DIALOG]: (state, payload) => {
    state.providerProductConfigurationDialog = payload
  },
  [SET_SELECTED_PROVIDER_PRODUCT]: (state, payload) => {
    state.selectedProviderProduct = payload
  },
  [SET_SELECTED_PROVIDER_PRODUCT_CONFIGURATION]: (state, payload) => {
    state.providerProductConfigurationIndex = payload
  },
  [SET_ACCOUNT_DEFAULT_FILTERS_VALUES_APPLIED]: (state, payload) => {
    state.accountDefaultFiltersValuesApplied = payload
  },
  [SET_PRE_SETTLEMENT_FOLDER_CONFIGURATION]: (state, payload) => {
    state.preSettlementFolderConfiguration = payload
  },
  [SET_USERS]: (state, payload) => {
    state.users = payload
  },
  [REASSIGNED_BILLS_SUCCESS]: (state, payload) => {
    state.accountDetail.reassignedAccounts.accounts = payload.content
    state.accountDetail.reassignedAccounts.links = payload.links
    state.accountDetail.reassignedAccounts.page = payload.page
  },
  [REASSIGNED_ACCOUNTS_LOADING]: (state, payload) => {
    state.accountDetail.reassignedAccounts.loadingAccounts = payload
  },
}
